export default "__VITE_ASSET__nBxeMGro__"